import React from "react"
import styled from "styled-components"
import theme from "../../../styles/theme"
import bodyStyles from "./bodyStyles"

const { breakPoints: { screenQuery } } = theme

const Body6 = styled.p(bodyStyles, `
  font-size: 14px;
  line-height: 16px;
  ${screenQuery.large}{
    font-size: 13px;
    line-height: 14px;
  }
  ${screenQuery.small}{
    font-size: 11px;
    line-height: 12px;
  }
  p {
    font-size: 14px;
    line-height: 16px;
    ${screenQuery.large}{
      font-size: 13px;
      line-height: 14px;
    }
    ${screenQuery.small}{
      font-size: 11px;
      line-height: 12px;
    }
  }
`)

export default ({
  children,
  ...props
}) =>
  (
    <Body6
      {...props}
    >
      {children}
    </Body6>
  )
